var $class="se2--wiztopic-keyword",$name="WiztopicKeyword",$path="app/components/WiztopicKeyword/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';
import isMobileBreakpoint from 'app/utilities/isMobileBreakpoint';

export default shell.registerComponent($this, ({
  mount, configs, addEventListener,
}) => {
  mount((element) => {
    const descriptionElement = element.querySelector('.description');
    const showMoreLinkElement = element.querySelector('.learn-more');
    const showLessLinkElement = element.querySelector('.learn-less');
    const showMorePlaceholderElement = element.querySelector('.show-all-placeholder');
    const keywordAutoHeightClassName = 'keyword-auto-height';
    const shadowElementSelector = '.shadow';
    const enableShowMoreLink = () => {
      // eslint-disable-next-line no-unused-expressions
      showLessLinkElement?.classList.contains(configs.css.classNames.hide)
        ? ''
        : showLessLinkElement?.classList.add(configs.css.classNames.hide);
      if (!isMobileBreakpoint()) return;
      element.querySelector(shadowElementSelector)?.classList.remove(configs.css.classNames.hide);
      descriptionElement?.classList.remove(keywordAutoHeightClassName);
      showMoreLinkElement?.classList.remove(configs.css.classNames.hide);
      showMorePlaceholderElement?.classList.toggle(
        configs.css.classNames.hide,
        (descriptionElement?.scrollHeight - descriptionElement?.clientHeight) <= 1,
      );
    };

    const enableShowLessLink = () => {
      element.querySelector(shadowElementSelector)?.classList.add(configs.css.classNames.hide);
      showMoreLinkElement?.classList.add(configs.css.classNames.hide);
      descriptionElement?.classList.add(keywordAutoHeightClassName);
      showLessLinkElement?.classList.remove(configs.css.classNames.hide);
    };

    addEventListener(showMoreLinkElement, 'click', enableShowLessLink);
    addEventListener(showLessLinkElement, 'click', enableShowMoreLink);
    enableShowMoreLink();
    addEventListener(window, 'resize', enableShowMoreLink);
  });
});
